import type { UseValidateOptions } from "./validation.type";

import get from "lodash/get";

import { client } from "@/config/client";
import { useModelMutation } from "@/hooks/queries";

export const useValidateModel = (
  model: "observations",
  id: number,
  options?: UseValidateOptions
) => {
  return useModelMutation(model, id, {
    ...(options ?? {}),
    mutationFn: () => get(client, [model, "validate"])(id),
  });
};
